import { render, staticRenderFns } from "./DataMonitorsPage.vue?vue&type=template&id=c07d0c10&scoped=true"
import script from "./DataMonitorsPage.vue?vue&type=script&lang=js"
export * from "./DataMonitorsPage.vue?vue&type=script&lang=js"
import style0 from "./DataMonitorsPage.vue?vue&type=style&index=0&id=c07d0c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07d0c10",
  null
  
)

export default component.exports